<mat-divider></mat-divider>
<div class="footer" (click)="$event.stopPropagation()">
  @if (footerType[label] !== "radio") {
    <button
      mat-stroked-button
      [class]="{
        'button-list-footer-btn': true,
        grey: !footerType[label] || footerType[label] === 'reset',
        empty: footerType[label] === 'incident'
      }"
      (click)="onClearItems()"
    >
      {{
        (showAllVariant
          ? "misc.showAll"
          : footerType[label] === "reset"
            ? "misc.reset"
            : "misc.clear"
        ) | translate
      }}
    </button>
  }
  @if (footerType[label] === "incident") {
    <button
      mat-stroked-button
      class="button-list-footer-btn white"
      (click)="onDisplayMore()"
    >
      {{ ("misc.more" | translate) + "..." }}
    </button>
  }

  @if (!isLoading) {
    <button
      mat-stroked-button
      class="button-list-footer-btn blue"
      (click)="onApplyItems()"
    >
      {{ (!isNewIncident ? "misc.apply" : "misc.new") | translate }}
    </button>
  }
  @if (isLoading && footerType[label] === "incident") {
    <div class="button-list-spinner-container">
      <mat-spinner class="button-list-spinner" [diameter]="16"></mat-spinner>
    </div>
  }
</div>
